import { Anchor, Text } from "@mantine/core";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";

type TokenDescriptionProps = {
  description: string;
};

export const TokenDescription = ({ description }: TokenDescriptionProps) => (
  <Text size="sm">
    <ReactMarkdown
      remarkPlugins={[gfm]}
      components={{
        a: (props) => (
          <Anchor
            {...props}
            sx={{
              fontSize: 14,
              textDecoration: "underline",
              wordBreak: "break-word",
            }}
          />
        ),
      }}
    >
      {description ?? ""}
    </ReactMarkdown>
  </Text>
);
